interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div
      className={`mb-8 md:mb-12 ${isCenter ? "text-center mx-auto max-w-2xl" : "max-w-3xl"}`}
      data-reveal
    >
      <div
        className={`flex items-center gap-2 ${isCenter ? "justify-center" : ""}`}
      >
        <span className="h-4 w-1 rounded-full bg-accent-500" />
        <span className="text-xs md:text-sm font-medium tracking-[0.2em] text-accent-700 uppercase">
          {eyebrow}
        </span>
      </div>
      <h2 className="mt-3 text-2xl md:text-4xl font-bold text-foreground-950 tracking-tight">
        {title}
      </h2>
      {desc ? (
        <p className="mt-3 md:mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
          {desc}
        </p>
      ) : null}
    </div>
  );
}